<template>
    <div>
        <div v-for="(item,index) in list" :key="index">
            <el-submenu v-if="item.subMenu.length>0&&item.hasMenu" :index="item.menuId">
                <template slot="title">
                    <i v-if="item.menuIcon" :class="item.menuIcon"></i>
                    <i v-if="!item.menuIcon" class="el-icon-setting"></i>
                    <span v-show="!isCollapse">{{ item.menuName }}</span>
                </template>
                <menu-tree :list="item.subMenu"></menu-tree>
            </el-submenu>

            <el-menu-item v-if="item.subMenu.length<1&&item.hasMenu" :index="item.menuUrl">
                <i v-if="item.menuIcon" :class="item.menuIcon"></i>
                <i  v-if="!item.menuIcon" class="el-icon-setting"></i>
                <span slot="title" >{{ item.menuName }}</span>
            </el-menu-item>

        </div>
    </div>
</template>

<script>
    export default {
        name: "MenuTree",
        props: ['list', 'isCollapse'],
    }
</script>

<style lang="scss">
    .el-menu-item, .el-submenu__title {
        margin-left: -20px;
        padding: 0 10px;
        height: 36px;
        line-height: 36px;
        /*border-width: 1px;*/
        /*border-style: solid;*/
        /*border-color: #95B8E7;*/
        /*border-top:0px;*/
    }

    .el-submenu .el-menu-item {
        height: 36px;
        line-height: 36px;
        /*background-color: #e4e4e4!important;*/

        /*border-width: 1px;*/
        /*border-style: solid;*/
        /*border-color: #95B8E7;*/
        /*border-top:0px;*/
    }

    .el-menu-item:hover,
    .el-menu-item:focus {
        /*background: linear-gradient(to right, #7bbfea, #3091f2 );*/
        background-color: #95B8E7 !important;
    }

    .el-submenu__title:hover {
        /*background: linear-gradient(to right, #7bbfea, #3091f2 );*/
        background-color: #95B8E7 !important;
    }

    /*  .el-submenu__title::before,.el-menu-item::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(-45deg, transparent 30%, transparent, rgba(255, 255, 255, .5), transparent 70%) no-repeat;
        background-size: 200% 200%;
        background-position: 200% 200%;
      }*/

    /*  .el-submenu__title:hover::before,.el-menu-item:hover::before {
        transition: background-position 2s;
        background-position: -100% -100%;
      }*/
</style>
